/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geototalpeople2Inputs */

const en_geototalpeople2 = /** @type {(inputs: Geototalpeople2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People`)
};

const de_geototalpeople2 = /** @type {(inputs: Geototalpeople2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personen`)
};

/**
* | output |
* | --- |
* | "People" |
*
* @param {Geototalpeople2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geototalpeople2 = /** @type {((inputs?: Geototalpeople2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geototalpeople2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geototalpeople2(inputs)
	return de_geototalpeople2(inputs)
});
export { geototalpeople2 as "geoTotalPeople" }